import React from 'react';
import autoxiumMark from '../assets/brand/autoxium-mark.png';

const AutoxiumLogo = ({ className = '', width = 140, height = 32, variant = 'default', wordmarkClassName = '' }) => {
  // AX mark + AUTOXIUM wordmark - Blue branding
  // Default: Blue text for light backgrounds
  // Light: White text for dark backgrounds
  const colors = {
    default: '#1E40AF', // Primary Blue
    light: '#FFFFFF',   // White for dark backgrounds
    dark: '#1E40AF',    // Primary Blue
  };

  const textColor = colors[variant] || colors.default;
  // The mark's navy fish/"A" disappear on dark backgrounds, so there it sits
  // on a white rounded tile (same treatment as the favicon).
  const onDark = variant === 'light';

  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="autoxium-logo">
      <span
        className={`inline-flex shrink-0 items-center justify-center ${onDark ? 'bg-white rounded-md' : ''}`}
        style={{ width: height, height, padding: onDark ? Math.round(height * 0.08) : 0 }}
      >
        <img
          src={autoxiumMark}
          alt=""
          className="block h-full w-full object-contain"
          data-testid="autoxium-logo-mark"
        />
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 150 32"
        fill="none"
        width={width}
        height={height}
        className={wordmarkClassName}
        data-testid="autoxium-logo-svg"
      >
        <text
          x="0"
          y="26"
          fontFamily="Arial, Helvetica, sans-serif"
          fontSize="28"
          fontWeight="bold"
          fill={textColor}
          letterSpacing="-1"
        >
          AUTOXIUM
        </text>
      </svg>
    </span>
  );
};

export default AutoxiumLogo;
